<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container-subscribers">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :defaultColDef="defaultColDef"
          :columnDefs="subscribersColumnDefs"
          :rowData="subscribers"
          :gridOptions="subscribersGridOptions"
          @grid-ready="onSubscriberGridReady"
          @first-data-rendered="onSubscribersFirstDataRendered"
          @modelUpdated="onSubscribersModelUpdated"
          @rowSelected="onSubscribersRowSelected"
          @rowDoubleClicked="onSubscribersRowDoubleClicked"
          @cellContextMenu="onSubscribersRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>
    <el-row type="flex" justify="space-between" style="margin-top: 15px">
      <el-col :span="1"> </el-col>
      <el-col :span="23" style="text-align:right;">
        <el-button
          type="primary"
          size="small"
          @click="searchSubscribersModal = true"
          v-shortkey="{ F7: ['f7'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F7</span
          >{{ $t("common.buttons.searchSubscribers") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="subscribersCardBtnDisabled"
          @click="onSubscribersCardBtn"
          v-shortkey="{ F9: ['f9'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F9</span
          >{{ $t("common.buttons.subscriberCard") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('subscribers.searchSubscribers.modal.title')"
      :visible.sync="searchSubscribersModal"
      :close-on-click-modal="false"
      @close="searchSubscribersModalHide"
      width="55%"
      top="1em"
      v-draggable
    >
      <div class="more-info__inner" ref="searchSubscribers">
        <el-form
          :model="searchSubscribersForm"
          :rules="searchSubscribersRules"
          ref="searchSubscribersForm"
        >
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.abcode") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.abcode"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.abcodeTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.fio") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.fio"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.fioTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.region") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <el-input-number
                  placeholder="0"
                  v-model="searchSubscribersForm.coderegionCode"
                  @blur="onChangeCoderegionCode"
                  @keyup.enter.native="onChangeCoderegionCode"
                  :precision="0"
                  :controls="false"
                  size="small"
                  style="width: 100%;"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.regionCode"
                  :placeholder="$t('common.components.select.placeholder')"
                  clearable
                  filterable
                  style="width: 100%;"
                  size="small"
                >
                  <el-option
                    v-for="item in params.gregion.data"
                    :key="item.coder"
                    :label="item.namerg"
                    :value="item.coder"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.street") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item>
                <el-input-number
                  placeholder="0"
                  v-model="searchSubscribersForm.codestreetCode"
                  @blur="onChangeCodestreetCode"
                  @keyup.enter.native="onChangeCodestreetCode"
                  :precision="0"
                  :controls="false"
                  size="small"
                  style="width: 100%;"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="17">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.streetCode"
                  :placeholder="$t('common.components.select.placeholder')"
                  clearable
                  filterable
                  style="width: 100%;"
                  size="small"
                >
                  <el-option
                    v-for="item in streets"
                    :key="`${item.coder}${item.codestreet}`"
                    :label="`${item.typestr} ${item.namestreet}`"
                    :value="item.codestreet"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.house") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input-number
                  placeholder="0"
                  v-model="searchSubscribersForm.nHouse"
                  :precision="0"
                  :controls="false"
                  size="small"
                  style="width: 100%;"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.charHouse"
                  clearable
                  @input="
                    v => {
                      searchSubscribersForm.charHouse = v.toUpperCase();
                    }
                  "
                  maxlength="3"
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item>
                <div style="text-align: right;">
                  {{ $t("subscribers.searchSubscribers.form.abcode") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.corpHouse"
                  clearable
                  @input="
                    v => {
                      searchSubscribersForm.corpHouse = v.toUpperCase();
                    }
                  "
                  maxlength="3"
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.flat") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input-number
                  placeholder="0"
                  v-model="searchSubscribersForm.nFlat"
                  :precision="0"
                  :controls="false"
                  size="small"
                  style="width: 100%;"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.charFlat"
                  clearable
                  @input="
                    v => {
                      searchSubscribersForm.charFlat = v.toUpperCase();
                    }
                  "
                  maxlength="3"
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="13"></el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.ncount") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.ncount"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.ncountTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("subscribers.searchSubscribers.form.docnumber") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.docnumber"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.docnumberTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.eic") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.eic"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.eicTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("subscribers.searchSubscribers.form.dateBegin") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item>
                <el-date-picker
                  v-model="searchSubscribersForm.dateBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item>
                <div style="text-align: right;">
                  {{ $t("subscribers.searchSubscribers.form.dateEnd") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item style="text-align: right;">
                <el-date-picker
                  v-model="searchSubscribersForm.dateEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.nact") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.nact"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.nactTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("subscribers.searchSubscribers.form.accountNumber") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-input-number
                  placeholder="0"
                  v-model="searchSubscribersForm.accountNumber"
                  :precision="0"
                  :controls="false"
                  size="small"
                ></el-input-number>
              </el-form-item>
            </el-col>
            <el-col :span="14"> </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.fiofiz") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.fiofiz"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.fiofizTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>{{ $t("subscribers.searchSubscribers.form.phone") }}</div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.phone"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.phoneTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("subscribers.searchSubscribers.form.numberhouses") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchSubscribersForm.numberhouses"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchSubscribersForm.numberhousesTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="searchSubscribersFormSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.search") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="searchSubscribersFormClear"
              v-shortkey="{ F12: ['f12'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F12</span
              >{{ $t("common.buttons.clear") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="searchSubscribersModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <SubscriberCard
      :abcode="currentSubscribersAbcode"
      :userinfo="currentSubscribersUserInfo"
    ></SubscriberCard>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import { AllCommunityModules } from "@ag-grid-community/all-modules";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import SubscriberCard from "@/components/SubscriberCard";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";
import { checkAccess } from "@/helpers/access";

export default {
  name: "subscribers",
  components: {
    AgGridVue,
    SubscriberCard
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    return {
      agGridModules: AllCommunityModules,
      agGridlocaleText: null,
      subscribersGridOptions: null,
      subscribersGridApi: null,
      subscribersColumnApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      subscribersColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.abcodeLong"),
          headerTooltip: this.$t("common.gridColumns.abcodeLong"),
          field: "abcode",
          tooltipField: "abcode",
          cellClass: "reporting-month",
          sort: "asc",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.fio"),
          headerTooltip: this.$t("common.gridColumns.fio"),
          field: "fio",
          tooltipField: "fio",
          cellClass: "reporting-month",
          width: 350,
          suppressSizeToFit: true
        },
        {
          headerName: this.$t("common.gridColumns.regionName"),
          headerTooltip: this.$t("common.gridColumns.regionName"),
          field: "regionname",
          tooltipField: "regionname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.streetName"),
          headerTooltip: this.$t("common.gridColumns.streetName"),
          field: "streetname",
          tooltipField: "streetname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.house"),
          headerTooltip: this.$t("common.gridColumns.house"),
          field: "nhouse",
          tooltipField: "nhouse",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.charHouseLong"),
          headerTooltip: this.$t("common.gridColumns.charHouseLong"),
          field: "charhouse",
          tooltipField: "charhouse",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.nFlat"),
          headerTooltip: this.$t("common.gridColumns.nFlat"),
          field: "nflat",
          tooltipField: "nflat",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.charFlatLong"),
          headerTooltip: this.$t("common.gridColumns.charFlatLong"),
          field: "charflat",
          tooltipField: "charflat",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.postIndex"),
          headerTooltip: this.$t("common.gridColumns.postIndex"),
          field: "postindex",
          tooltipField: "postindex",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.phone"),
          headerTooltip: this.$t("common.gridColumns.phone"),
          field: "phone",
          tooltipField: "phone",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.dateCreate"),
          headerTooltip: this.$t("common.gridColumns.dateCreate"),
          field: "datecreate",
          tooltipField: "datecreate",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.dateClose"),
          headerTooltip: this.$t("common.gridColumns.dateClose"),
          field: "dateclose",
          tooltipField: "dateclose",
          comparator: (date1, date2) =>
            parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
            parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
        },
        {
          headerName: this.$t("common.gridColumns.closeReasonName"),
          headerTooltip: this.$t("common.gridColumns.closeReasonName"),
          field: "closereasonname",
          tooltipField: "closereasonname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.habitName"),
          headerTooltip: this.$t("common.gridColumns.habitName"),
          field: "habitname",
          tooltipField: "habitname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.propertyName"),
          headerTooltip: this.$t("common.gridColumns.propertyName"),
          field: "propertyname",
          tooltipField: "propertyname",
          cellClass: "reporting-month"
        },
        {
          headerName: this.$t("common.gridColumns.arch"),
          headerTooltip: this.$t("common.gridColumns.arch"),
          field: "narch",
          tooltipField: "narch",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.countRoom"),
          headerTooltip: this.$t("common.gridColumns.countRoom"),
          field: "countroom",
          tooltipField: "countroom",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.partyHouse"),
          headerTooltip: this.$t("common.gridColumns.partyHouse"),
          field: "partyhouse",
          tooltipField: "partyhouse",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.floor"),
          headerTooltip: this.$t("common.gridColumns.floor"),
          field: "floor",
          tooltipField: "floor",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        },
        {
          headerName: this.$t("common.gridColumns.clientId"),
          headerTooltip: this.$t("common.gridColumns.clientId"),
          field: "clientid",
          tooltipField: "clientid",
          comparator: (value1, value2) => parseInt(value1) - parseInt(value2)
        }
      ],
      searchSubscribersModal: false,
      searchSubscribersForm: {
        abcode: "",
        abcodeTypeSearch: "1",
        fio: "",
        fioTypeSearch: "1",
        coderegionCode: null,
        regionCode: null,
        codestreetCode: null,
        streetCode: null,
        nHouse: 0,
        charHouse: "",
        corpHouse: "",
        nFlat: 0,
        charFlat: "",
        ncount: "",
        ncountTypeSearch: "1",
        docnumber: "",
        docnumberTypeSearch: "1",
        eic: "",
        eicTypeSearch: "1",
        dateBegin: "",
        dateEnd: "",
        nact: "",
        nactTypeSearch: "1",
        accountNumber: 0,
        fiofiz: "",
        fiofizTypeSearch: "1",
        phone: "",
        phoneTypeSearch: "1",
        numberhouses: "",
        numberhousesTypeSearch: "1"
      },
      searchSubscribersRules: {},
      searchTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchTypes.matches")
        },
        {
          value: "1",
          label: this.$t("common.options.searchTypes.contains")
        },
        {
          value: "2",
          label: this.$t("common.options.searchTypes.startsOn")
        },
        {
          value: "3",
          label: this.$t("common.options.searchTypes.endsOn")
        }
      ],
      streets: [],
      subscribersCardBtnDisabled: true,
      currentSubscribersRowSelected: null,
      currentSubscribersAbcode: null,
      currentSubscribersUserInfo: ""
    };
  },
  computed: {
    ...mapGetters(["subscribers", "subscriberCardModal", "initPage", "params"])
  },
  watch: {
    "searchSubscribersForm.regionCode": function(value) {
      this.searchSubscribersForm.coderegionCode = +value || null;

      this.searchSubscribersForm.codestreetCode = null;
      this.searchSubscribersForm.streetCode = null;

      this.streets = value
        ? [...this.params.street.data.filter(item => item.coder === value)]
        : [...this.params.street.data];
    },
    "searchSubscribersForm.streetCode": function(value) {
      this.searchSubscribersForm.codestreetCode = +value || null;
    }
  },
  beforeCreate() {
    if (!checkAccess(84)) {
      this.$router.push("/");
    }
  },
  async created() {
    document.title = this.$t("subscribers.title");
    await this.getParams({
      street: "1",
      gregion: "1",
      gproperty: "1",
      ghabit: "1",
      gclientclosereason: "1"
    });
    this.initStreets();

    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    this.clearSubscribers();

    window.removeEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.subscribersGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };
  },
  mounted() {
    this.searchSubscribersModal = true;
  },
  methods: {
    ...mapMutations([
      "clearSubscribers",
      "setSubscriberCardModal",
      "setGridContextMenuModal",
      "setGridContextMenuKey",
      "setGridContextMenuEvent"
    ]),
    ...mapActions(["getSubscribers", "getParams"]),
    onSubscriberGridReady(params) {
      this.subscribersGridApi = params.api;
      this.subscribersColumnApi = params.columnApi;
    },
    onSubscribersFirstDataRendered(event) {
      setGridView("wb-subscribers-grid-subscribers", event, "full");
    },
    onSubscribersRowRightClicked(event) {
      this.setGridContextMenuKey("wb-subscribers-grid-subscribers");
      this.setGridContextMenuEvent(event);
      this.setGridContextMenuModal(true);
    },
    onSubscribersModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.subscribersCardBtnDisabled = rowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onSubscribersRowSelected(params) {
      if (params.node.selected) {
        this.currentSubscribersRowSelected = params.node.data;
      }
    },
    onSubscribersRowDoubleClicked() {
      this.onSubscribersCardBtn();
    },
    searchSubscribersModalHide() {
      this.$refs.searchSubscribers.scrollTo(0, 0);
    },
    searchSubscribersFormSubmit() {
      const {
        abcode,
        abcodeTypeSearch,
        fio,
        fioTypeSearch,
        regionCode,
        streetCode,
        nHouse,
        charHouse,
        corpHouse,
        nFlat,
        charFlat,
        ncount,
        ncountTypeSearch,
        docnumber,
        docnumberTypeSearch,
        eic,
        eicTypeSearch,
        dateBegin,
        dateEnd,
        nact,
        nactTypeSearch,
        accountNumber,
        fiofiz,
        fiofizTypeSearch,
        phone,
        phoneTypeSearch,
        numberhouses,
        numberhousesTypeSearch
      } = this.searchSubscribersForm;

      this.searchSubscribersModal = false;

      if (this.subscribersGridOptions.api) {
        this.subscribersGridOptions.api.setRowData([]);
        this.subscribersGridOptions.api.showLoadingOverlay();
      }
      this.getSubscribers({
        abcode,
        abcodeTypeSearch,
        fio,
        fioTypeSearch,
        region: regionCode || "",
        street: streetCode || "",
        nHouse,
        charHouse,
        corpHouse,
        nFlat,
        charFlat,
        ncount,
        ncountTypeSearch,
        docnumber,
        docnumberTypeSearch,
        eic,
        eicTypeSearch,
        dateBegin,
        dateEnd,
        nact,
        nactTypeSearch,
        accountNumber,
        fiofiz,
        fiofizTypeSearch,
        phone,
        phoneTypeSearch,
        numberhouses,
        numberhousesTypeSearch
      });
    },
    searchSubscribersFormClear() {
      this.searchSubscribersForm = {
        abcode: "",
        abcodeTypeSearch: "1",
        fio: "",
        fioTypeSearch: "1",
        coderegionCode: null,
        regionCode: null,
        codestreetCode: null,
        streetCode: null,
        nHouse: 0,
        charHouse: "",
        corpHouse: "",
        nFlat: 0,
        charFlat: "",
        ncount: "",
        ncountTypeSearch: "1",
        docnumber: "",
        docnumberTypeSearch: "1",
        eic: "",
        eicTypeSearch: "1",
        dateBegin: "",
        dateEnd: "",
        nact: "",
        nactTypeSearch: "1",
        accountNumber: 0,
        fiofiz: "",
        fiofizTypeSearch: "1",
        phone: "",
        phoneTypeSearch: "1",
        numberhouses: "",
        numberhousesTypeSearch: "1"
      };
      this.clearSubscribers();
      this.initStreets();
      this.subscribersCardBtnDisabled = true;
    },
    initStreets() {
      this.streets = [...this.params.street.data];
    },
    onSubscribersCardBtn() {
      const {
        abcode,
        fio,
        regionname,
        streetname,
        nhouse,
        charhouse,
        nflat,
        charflat
      } = this.currentSubscribersRowSelected;
      this.currentSubscribersAbcode = abcode;

      const house =
        nhouse === "0" ? "" : `${this.$t("common.address.house")}${nhouse}`;
      const charHouse = charhouse !== "" ? `/${charhouse}` : "";
      const flat =
        nflat === "0" || nflat === ""
          ? ""
          : `${this.$t("common.address.flat")}${nflat}`;
      const charFlat = charflat !== "" ? `/${charflat}` : "";

      // тут нужна доработка
      this.currentSubscribersUserInfo = `${this.$t(
        "common.address.abcode"
      )} ${abcode}, ${fio}, ${this.$t(
        "common.address.address"
      )} ${regionname}, ${streetname} ${house}${charHouse} ${flat}${charFlat}`;

      this.setSubscriberCardModal(true);
    },
    onChangeCoderegionCode(event) {
      const value = event.target.value;
      const gregions = this.params.gregion.data.filter(
        item => item.coder === value
      );
      if (gregions.length > 0) {
        this.searchSubscribersForm.regionCode = value;
      } else {
        this.searchSubscribersForm.regionCode = null;
        this.searchSubscribersForm.coderegionCode = null;
      }
    },
    onChangeCodestreetCode(event) {
      const value = event.target.value;
      const streets = this.streets.filter(item => item.codestreet === value);
      if (streets.length > 0) {
        this.searchSubscribersForm.streetCode = value;
      } else {
        this.searchSubscribersForm.streetCode = null;
        this.searchSubscribersForm.codestreetCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "F7":
          // subscriber: set searchSubscribersModal
          if (!this.searchSubscribersModal && !this.subscriberCardModal) {
            this.searchSubscribersModal = true;
          }
          break;
        case "F9":
          // subscriber: call onSubscribersCardBtn
          if (
            !this.searchSubscribersModal &&
            !this.subscriberCardModal &&
            !this.subscribersCardBtnDisabled
          ) {
            this.onSubscribersCardBtn();
          }
          break;
        case "F10":
          // searchSubscribersModal: call searchSubscribersFormSubmit
          if (this.searchSubscribersModal && !this.subscriberCardModal) {
            this.searchSubscribersFormSubmit();
          }
          break;
        case "F12":
          // searchSubscribersModal: call searchSubscribersFormClear
          if (this.searchSubscribersModal && !this.subscriberCardModal) {
            this.searchSubscribersFormClear();
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-container-subscribers {
  height: calc(100vh - 137px);
  overflow-y: auto;
}
.link-item {
  margin-bottom: 16px;
}
</style>

<style lang="scss">
.el-input-number .el-input__inner {
  text-align: left;
}
</style>
